import { render, staticRenderFns } from "./JudgesUpload.vue?vue&type=template&id=5ec6e752&scoped=true"
import script from "./JudgesUpload.vue?vue&type=script&lang=js"
export * from "./JudgesUpload.vue?vue&type=script&lang=js"
import style0 from "./JudgesUpload.vue?vue&type=style&index=0&id=5ec6e752&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec6e752",
  null
  
)

export default component.exports